/**
 * @desc 查询季度计划列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanQuarterQueryRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanQuarterResponse>>> {
  return defHttp.post({
    url: '/wap/plan/quarter/query',
    data,
  });
}

export function mock(
  data: defs.PlanQuarterQueryRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanQuarterResponse>>> {
  return defHttp.post({
    url: '/mock/wap/plan/quarter/query',
    data,
  });
}
